// extracted by mini-css-extract-plugin
export default {"root":"EventPopup_root__-7LlU","reference":"EventPopup_reference__7fPug","invalid":"EventPopup_invalid__5C7TW"};